import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowRight",
  "use": "icon-arrowRight-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowRight\">\n<path d=\"M10 9.5V6.5L14 10.5L10 14.5V11.5H6V9.5H10ZM10 0.5C15.52 0.5 20 4.98 20 10.5C20 16.02 15.52 20.5 10 20.5C4.48 20.5 0 16.02 0 10.5C0 4.98 4.48 0.5 10 0.5ZM10 18.5C14.42 18.5 18 14.92 18 10.5C18 6.08 14.42 2.5 10 2.5C5.58 2.5 2 6.08 2 10.5C2 14.92 5.58 18.5 10 18.5Z\" fill=\"#2EB474\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrowRight.svg
// module id = /mtx
// module chunks = 111